<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > {{ 'Lista de diretórios' | translate}}
    </div>
</div>

<main class="container">
    <h1 i18n>{{ 'Lista de diretórios' | translate}}</h1>

    <div class="flex space-between filtros">
        <div class="filtros">
            <div class="filtro">
                <label for="status" i18n>{{ 'País' | translate}}</label>
                <select id="status" [(ngModel)]="filtro.pais" (change)="atualizaFiltro()">
                    <option value="" i18n>{{ 'Todos' | translate}}</option>
                    <option *ngFor="let status of jsonPaises" [value]="status.id">{{status.name}}</option>
                </select>
            </div>
            <div class="filtro">
                <label for="search" i18n>{{ 'Pesquisar por caminho' | translate}}</label>
                <input type="text" id="search" [(ngModel)]="filtro.search" (keyup)="atualizaFiltro()">
            </div>
            <div class="filtro">
                <label i18n>{{ 'Limpar filtros' | translate}}</label>
                <button (click)="limparFiltro()" class="red_button" i18n>{{ 'Limpar' | translate}}</button>
            </div>
        </div>
        
        <div class="add_group_button filtro">
            <label i18n>&nbsp;</label>
            <button (click)="adicionarDiretorio()" class="red_button" i18n>{{ 'Adicionar diretório' | translate}}</button>
        </div>
    </div>

    <table border="0" cellpadding="0" cellspacing="0">
    <thead>
        <tr>
            <th i18n>#</th>
            <th i18n>{{ 'País' | translate}}</th>
            <th i18n>{{ 'Caminho' | translate}}</th>
            <th i18n>{{ 'Ano do filtro' | translate}}</th>
            <th i18n>{{ 'Mês do filtro' | translate}}</th>
            <th i18n>{{ 'Limitar PDVs' | translate}}</th>
            <th i18n>{{ 'Total de PDVs' | translate}}</th>
            <th i18n>{{ 'Ações' | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor='let item of listaShowItens  | paginate: { itemsPerPage: 15, currentPage: currentPage }; let i = index'>
            <td>
                {{ (currentPage - 1) * 15 + i + 1 }}
            </td>
            <td>
                {{getCountry(item.countryId)}}
            </td>
            <td>
                {{item.rootPath}}
            </td>
            <td>
                {{item.filterYear}}
            </td>
            <td>
                {{item.filterMonth}}
            </td>
            <td>
                {{ (item.isLimitPdvs ? 'Sim' : 'Não') | translate }}
            </td>
            <td>
                {{ item.isLimitPdvs ? (item.totalPdvs ?? '-') : '-' }}
            </td>
            <td>
                <a (click)="editarDiretorio(item)" class="light_button" title="{{ 'Ver detalhes' | translate}}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/><path d="M14 3v5h5M16 13H8M16 17H8M10 9H8"/></svg>
                </a>

                <a (click)="removeGroup(item)" class="dark_button" title="{{ 'Remover' | translate}}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                </a>
            </td>
        </tr>
    </tbody>
    </table>

    <div class="text-center pagination">
        <div class="pagination-controls">
            <pagination-controls (pageChange)="currentPage = $event" previousLabel="" nextLabel=""></pagination-controls>
        </div>
    </div>
</main>
